import React from "react";
import { Box, Typography } from "@mui/material";
import StepContent from "./StepContent";

const StepContainer = ({ steps, height }) => {
  return (
    <Box
      elevation={3}
      sx={{
        border: "1px solid #1976d2",
        borderRadius: 2,
        backgroundColor: "white",
        // borderBottom
      }}
    >
      {steps?.length ? (
        steps.map((step, index) => (
          <StepContent
            key={index}
            date={step.date}
            status={step.newStatus}
            description={step.description}
          />
        ))
      ) : (
        <Box
          style={{
            height: "100%",
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="textSecondary">
            Etapa não iniciada
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default StepContainer;
